import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.shapes_uploads_check_page', () => {
  void import('./internal/check').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.shapes_upload_form', () => {
  void import('./internal/new').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.shapes_upload_select_page', () => {
  void import('./internal/select').then(({ default: Component }) => Component());
});
